export const DEPLOYMENT_NETWORKS = [
  "avalanche",
  "ethereum",
  "ethereum-sepolia",
  "optimism",
] as const;

export type DeploymentNetwork = (typeof DEPLOYMENT_NETWORKS)[number];

export const THIRD_PARTY_CONTRACT_NETWORK_TYPES = ["mainnet", "testnet"] as const;

export type ThirdPartyContractNetworkType =
  (typeof THIRD_PARTY_CONTRACT_NETWORK_TYPES)[number];

export const PAGE_SIZE = 10;

/** Page size for the global deployment templates list (`GET /deployment-templates`). */
export const DEPLOYMENT_TEMPLATES_PAGE_SIZE = 20;
